import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Buttons/Button';
import NumberControl from '../../../components/Fields/NumberControl';
import SelectListControl from '../../../components/Fields/SelectListControl';
import TextboxField from '../../../components/Fields/TextboxField';
import { ControlProps, FieldProps } from '../../../components/Fields/Types';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import { useNotifications } from '../../../contexts/notificationContext';
import AttachmentVersionModel from '../../../models/AttachmentVersionModel';
import BillOfMaterialItemFileModel from '../../../models/BillOfMaterialItemFileModel';
import BillOfMaterialItemModel from '../../../models/BillOfMaterialItemModel';
import DataService from "../../../services/data.service";
import { DataResult } from '../../../types/Result';
import BillOfMaterials_popup_AddReferencePicture from '../Popups/BillOfMaterials_popup_AddReferencePicture';
import BillOfMaterials_popup_DeleteReferencePicture from '../Popups/BillOfMaterials_popup_DeleteReferencePicture';
import ItemRevision_popup_AddItemToBOM from '../Popups/ItemRevision_popup_AddItemToBOM';

interface IProps {
    bomItem: BillOfMaterialItemModel
    bomItemIndex: number
    getControlProps: (string) => ControlProps
    getFieldProps: (string) => FieldProps
    refreshFormData: () => void
}

const CommentView: React.FC<IProps> = ({ bomItem, bomItemIndex, getControlProps, getFieldProps, refreshFormData }) => {
    const [referencePicture, setReferencePicture] = useState<BillOfMaterialItemFileModel>()
    const [showAddReferencePicturePopup, setShowAddReferencePicturePopup] = useState<boolean>(false)
    const [showDeleteReferencePicturePopup, setShowDeleteReferencePicturePopup] = useState<boolean>(false)
    const [showAddItemPopup, setShowAddItemPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const navigate = useNavigate()

    const itemRevisions = useSelectListOptions('api/v1/selectlist/itemRevisions?itemId=' + bomItem.itemId, '-- Latest version');

    function deleteRow() {
        DataService.delete('api/v1/BillOfMaterialItems/', bomItem.id)
            .then(response => {
                handleResult(response);
                refreshFormData();
            })
            .catch(e => { handleException(e); });
    }

    var borderColor = 'black'
    if (bomItem.item.isActive === false)
        borderColor = 'red'
    if (bomItem.itemRevision?.isActive === false)
        borderColor = 'red'

    let udfs = bomItem.userDefinedFields.map((udf, index) => {
        return (
            <TextboxField {...getFieldProps(`billOfMaterialItems.${bomItemIndex}.userDefinedFields.${index}.value`) }/>
        )
    })

    let images = bomItem.referencePictures.map((referencePicture, index) => {
        return (
            <div style={{ display:'inline' }}>
                <img style={{ maxWidth: 128, margin: 5 }} src={referencePicture.url} onClick={() => { setReferencePicture(referencePicture); setShowDeleteReferencePicturePopup(true) }} />
            </div>
        );
    })

    function navigateToItem() {
        if (bomItem.url)
            navigate('/plm/Items/ItemRevision/' + bomItem.itemRevision.id)
        else
            setShowAddItemPopup(true)
    }

    function downloadDefaultAttachment() {
        DataService.get<DataResult<AttachmentVersionModel>>('api/v1/ItemAttachments/DefaultForItem/' + bomItem.itemId + '/' + bomItem.itemRevisionId)
            .then(response => {
                handleResult(response);
                if (response.data) {
                    const link = document.createElement('a');
                    link.href = response.data.fileUrl;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
    }

    let imageUrl = bomItem.url;
    if (!bomItem.url)
        imageUrl = '/Images/Difuzed/1x1_image.jpg'

    return (
        <>
            <td onClick={navigateToItem}  style={{ backgroundColor: bomItem.backgroundColor }}></td>
            <td onClick={navigateToItem}>
                <div style={{ maxWidth: 100, overflow: 'hidden', border: '1px solid ' + borderColor, display: 'inline-block' }}>
                    <img height='100' src={imageUrl} />
                    {borderColor === 'red' && (<div style={{ textAlign: 'center', width: '100%', color: 'white', background: 'red' }}>Inactive</div>)}
                </div>
            </td>
            <td>
                <NumberControl {...getControlProps(`billOfMaterialItems.${bomItemIndex}.quantity`)} />
            </td>
            <td onClick={navigateToItem}>
                <b>{bomItem.itemType}:</b>
                <div>{bomItem.itemName}</div>
            </td>
            <td>
                <b onClick={navigateToItem}>{`${bomItem.itemNr}-v${bomItem.itemRevision?.revisionNumber ?? '?'}`}</b>
                <div>
                    <SelectListControl {...getControlProps(`billOfMaterialItems.${bomItemIndex}.itemRevisionId`)} options={itemRevisions} />
                </div>
            </td>
            <td>
                {udfs}
            </td>
            <td>
                {images}
                <div style={{marginTop:10}}>
                    <Button type='button' variant='light' onClick={() => setShowAddReferencePicturePopup(true)}>
                        <i className="fa fa-picture-o"></i>
                    </Button>
                </div>
            </td>

            <td className="button-column">
                <span style={{ color: "rgb(137, 196, 244)" }} >
                    <i className="fa fa-cloud-download" onClick={downloadDefaultAttachment}></i>
                </span>
            </td>

            <td className="button-column">
                <span style={{ color: "rgb(243, 86, 93)" }} >
                    <i className="fa fa-trash" onClick={deleteRow}></i>
                </span>
            </td>
            {showAddReferencePicturePopup && <BillOfMaterials_popup_AddReferencePicture bomItem={bomItem} show={showAddReferencePicturePopup} onHide={() => { refreshFormData(); setShowAddReferencePicturePopup(false); }} />}
            {showDeleteReferencePicturePopup && referencePicture && <BillOfMaterials_popup_DeleteReferencePicture billOfMaterialItemFile={referencePicture} show={showDeleteReferencePicturePopup} onHide={() => { refreshFormData(); setShowDeleteReferencePicturePopup(false); }} />}
            {showAddItemPopup && <ItemRevision_popup_AddItemToBOM bom={bomItem.billOfMaterial} billOfMaterialId={bomItem.billOfMaterialId} billOfMaterialTemplateItemId={bomItem.billOfMaterialTemplateItemId} show={showAddItemPopup} onHide={() => { refreshFormData(); setShowAddItemPopup(false); }} />}
        </>
    );
}
export default CommentView